module.exports = __webpack_public_path__ + "static/media/synthetic drugsActive.67be23ae.svg";